import React from 'react';
import PropTypes from 'prop-types';
import { MdError } from 'react-icons/md';
import styled from 'styled-components';
import { $medium, $red } from '../../../styles';

const antdClassMap = {
  select: '.ant-select',
  text: '.ant-input',
  number: '.ant-input-number',
};

export const IMAGE_UPLOAD_URL = `${process.env.REACT_APP_BACKEND_URL}/upload`;

export const DEFAULT_VALID_IMAGE_TYPES = [
  'image/gif',
  'image/jpeg',
  'image/jpg',
  'image/png',
];

export const CrudFormButtonRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 2rem;
  span {
    font-style: italic;
    margin-left: auto;
  }
`;

export const AdminInputRow = styled.div`
  display: flex;
  ${({ flex }) => (flex ? `flex: ${flex};` : '')}
  > div {
    flex: 1;
    margin: 0 0.5rem;
  }
  margin: ${({ margin }) => margin || '1.25rem -0.5rem 0 -0.5rem'};
`;

export const ImageInputRow = styled(AdminInputRow)`
  > div {
    flex: 1;
    &:last-child {
      max-width: 21rem;
    }
    &:not(:last-child) {
      max-width: 8rem;
      .ant-upload-list-item-list-type-picture-card {
        height: 8rem;
        width: 8rem;
      }
    }
  }
`;

const ErrorContainer = styled.div`
  color: ${$red};
  font-size: 1rem;
  margin-top: 0.25rem;
  display: flex;
  align-items: center;
  span {
    margin-left: 0.5rem;
  }
`;

const RequiredAsterix = styled.span`
  color: ${$red};
`;

export const AdminInputWrapper = styled.div`
  ${({ type }) => type && `
    ${antdClassMap[type]} {
      width: 100%;
    }
  `}
`;

const Label = styled.div`
  margin-bottom: 0.5rem;
  font-weight: ${$medium};
  font-size: 1rem;
`;

export const AdminInputLabel = ({ children, required }) => (
  <Label>
    <span>{ children }</span>
    {
      required && <RequiredAsterix>*</RequiredAsterix>
    }
  </Label>
);

AdminInputLabel.propTypes = {
  children: PropTypes.node.isRequired,
  required: PropTypes.bool,
};

AdminInputLabel.defaultProps = {
  required: false,
};

export const AdminInputError = ({ children }) => (
  <ErrorContainer>
    <MdError />
    <span>
      { children }
    </span>
  </ErrorContainer>
);

AdminInputError.propTypes = {
  children: PropTypes.node.isRequired,
};
